/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRoomMatchConfirmationStatusRequest
 */
export interface UpdateRoomMatchConfirmationStatusRequest {
    /**
     * Confirmation status
     * @type {string}
     * @memberof UpdateRoomMatchConfirmationStatusRequest
     */
    confirmationStatus?: UpdateRoomMatchConfirmationStatusRequestConfirmationStatusEnum | null;
}


/**
 * @export
 */
export const UpdateRoomMatchConfirmationStatusRequestConfirmationStatusEnum = {
    Confirmed: 'confirmed',
    Rejected: 'rejected'
} as const;
export type UpdateRoomMatchConfirmationStatusRequestConfirmationStatusEnum = typeof UpdateRoomMatchConfirmationStatusRequestConfirmationStatusEnum[keyof typeof UpdateRoomMatchConfirmationStatusRequestConfirmationStatusEnum];


/**
 * Check if a given object implements the UpdateRoomMatchConfirmationStatusRequest interface.
 */
export function instanceOfUpdateRoomMatchConfirmationStatusRequest(value: object): value is UpdateRoomMatchConfirmationStatusRequest {
    return true;
}

export function UpdateRoomMatchConfirmationStatusRequestFromJSON(json: any): UpdateRoomMatchConfirmationStatusRequest {
    return UpdateRoomMatchConfirmationStatusRequestFromJSONTyped(json, false);
}

export function UpdateRoomMatchConfirmationStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoomMatchConfirmationStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmationStatus': json['confirmationStatus'] == null ? undefined : json['confirmationStatus'],
    };
}

export function UpdateRoomMatchConfirmationStatusRequestToJSON(json: any): UpdateRoomMatchConfirmationStatusRequest {
    return UpdateRoomMatchConfirmationStatusRequestToJSONTyped(json, false);
}

export function UpdateRoomMatchConfirmationStatusRequestToJSONTyped(value?: UpdateRoomMatchConfirmationStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmationStatus': value['confirmationStatus'],
    };
}

